(function(w,d){
  'use strict';
  if (w.__ES_SIZE_GUIDE_BOOT__) return;
  w.__ES_SIZE_GUIDE_BOOT__ = true;

  function init(){
    var root = d.querySelector('[data-es-size-guide]');
    if (!root) return;

    var body = d.body;
    var docEl = d.documentElement;
    var panel = root.querySelector('[data-es-size-guide-panel]');
    var overlay = root.querySelector('[data-es-size-guide-overlay]');
    var variantNode = root.querySelector('[data-es-size-guide-variant]');
    var accordionToggle = root.querySelector('[data-es-size-guide-accordion-toggle]');
    var accordionPanel = root.querySelector('[data-es-size-guide-accordion-panel]');
    var specsCard = root.querySelector('[data-es-size-guide-specs]');
    var specsGrid = root.querySelector('[data-es-size-guide-specs-grid]');
    var productSelect = d.getElementById('productSelect');
    if (!panel || !overlay) return;

    var openScrollY = 0;

    var specMap = [
      { key: 'frame-width', label: 'Frame width' },
      { key: 'lens-width', label: 'Lens width' },
      { key: 'bridge', label: 'Bridge' },
      { key: 'temple-length', label: 'Temple length' },
      { key: 'lens-height', label: 'Lens height' },
      { key: 'frame-weight', label: 'Weight' }
    ];

    function mountToBody(){
      if (panel.parentNode !== body) body.appendChild(panel);
      if (overlay.parentNode !== body) body.appendChild(overlay);
    }

    function setLocked(locked){
      if (locked){
        openScrollY = w.pageYOffset || docEl.scrollTop || body.scrollTop || 0;
        body.style.position = 'fixed';
        body.style.top = (-openScrollY) + 'px';
        body.style.left = '0';
        body.style.right = '0';
        body.style.width = '100%';
      } else {
        body.style.position = '';
        body.style.top = '';
        body.style.left = '';
        body.style.right = '';
        body.style.width = '';
        w.scrollTo(0, openScrollY);
      }
    }

    function setOpenClasses(isOpen){
      body.classList.toggle('es-size-guide-open', isOpen);
      docEl.classList.toggle('es-size-guide-open', isOpen);
      body.classList.toggle('es-size-guide-open-mobile', isOpen && w.innerWidth <= 767);
      docEl.classList.toggle('es-size-guide-open-mobile', isOpen && w.innerWidth <= 767);
    }

    function getCleanText(node){
      return ((node && node.textContent) ? node.textContent : '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
    }

    function updateVariantText(){
      if (!variantNode || !productSelect || !productSelect.options.length) return;
      var selectedOption = productSelect.options[productSelect.selectedIndex];
      if (!selectedOption) return;
      var raw = (selectedOption.textContent || '').split(' - ')[0].trim();
      if (!raw || raw === 'Default Title') {
        variantNode.textContent = '';
        variantNode.hidden = true;
        return;
      }
      variantNode.textContent = ' in ' + raw;
      variantNode.hidden = false;
    }

    function toggleAccordion(forceExpanded){
      if (!accordionToggle || !accordionPanel) return;
      var expanded = typeof forceExpanded === 'boolean' ? forceExpanded : (accordionToggle.getAttribute('aria-expanded') !== 'true');
      accordionToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      accordionPanel.hidden = !expanded;
    }

    function getDetailsScope(){
      return d.querySelector('.tab-pd-details #des') || d.querySelector('#des') || d;
    }

    function getValueFromSpecItem(item){
      if (!item) return '';
      var preferred = item.querySelector ? item.querySelector('.color-primary, .value') : null;
      var text = getCleanText(preferred || item);
      if (!text) return '';
      text = text.replace(/^\s*(Frame\s*Width|Lens\s*Width|Bridge|Temple\s*Length|Lens\s*Height|Frame\s*Weight|Weight)\s*:?\s*/i, '');
      text = text.replace(/^[-–—:]+\s*/, '');
      return text;
    }

    function buildSpecs(){
      if (!specsCard || !specsGrid) return;
      var scope = getDetailsScope();
      var html = '';
      var count = 0;

      for (var i = 0; i < specMap.length; i++) {
        var spec = specMap[i];
        var item = scope.querySelector ? scope.querySelector('li.' + spec.key) : null;
        var value = getValueFromSpecItem(item);
        if (!value) continue;
        var isPrimary = spec.key === 'frame-width';
        html += '<div class="es-size-guide__spec' + (isPrimary ? ' is-primary' : '') + '">' +
          '<div class="es-size-guide__spec-label">' + spec.label + '</div>' +
          '<div class="es-size-guide__spec-value">' + value + '</div>' +
          '</div>';
        count++;
      }

      specsGrid.innerHTML = html;
      specsCard.hidden = count === 0;
    }

    function syncGuide(){
      updateVariantText();
      buildSpecs();
    }

    function openGuide(){
      mountToBody();
      syncGuide();
      setLocked(true);
      setOpenClasses(true);
      overlay.classList.add('is-active');
      panel.classList.add('is-active');
      panel.setAttribute('aria-hidden', 'false');
    }

    function closeGuide(){
      panel.classList.remove('is-active');
      overlay.classList.remove('is-active');
      panel.setAttribute('aria-hidden', 'true');
      setOpenClasses(false);
      setLocked(false);
    }

    mountToBody();
    syncGuide();
    toggleAccordion(true);

    d.addEventListener('click', function(ev){
      var openBtn = ev.target && ev.target.closest ? ev.target.closest('[data-es-size-guide-open]') : null;
      if (openBtn) {
        ev.preventDefault();
        openGuide();
        return;
      }

      var outsidePanelClick = panel && panel.classList.contains('is-active') && ev.target && panel.contains(ev.target) && !(ev.target.closest && ev.target.closest('[data-es-size-guide-layout]'));
      if (outsidePanelClick) {
        ev.preventDefault();
        closeGuide();
        return;
      }

      var closeBtn = ev.target && ev.target.closest ? ev.target.closest('[data-es-size-guide-close], [data-es-size-guide-overlay]') : null;
      if (closeBtn) {
        ev.preventDefault();
        closeGuide();
        return;
      }

      var accordionBtn = ev.target && ev.target.closest ? ev.target.closest('[data-es-size-guide-accordion-toggle]') : null;
      if (accordionBtn) {
        ev.preventDefault();
        toggleAccordion();
      }
    }, true);

    d.addEventListener('keydown', function(ev){
      if (ev.key === 'Escape' && panel.classList.contains('is-active')) closeGuide();
    });

    if (productSelect) productSelect.addEventListener('change', syncGuide);
    w.addEventListener('pagehide', function(){
      if (panel.classList.contains('is-active')) closeGuide();
    });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})(window, document);
